import { Slide } from "@jelly/lesson";

import asd from "./components/asd";
import cae from "./components/cae";

const principle: Slide = {
  title: "Applications & Outlook",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Active Sound Design (ASD)" }, { name: "CAE" }],
          options: {},
        },
      ],
      components: [asd, cae],
      extraContent: [[]],
    },
  },
};

export default principle;
